<template>
    <div>
        Use the slider to estimate the percentage of content that will use the following dispositions.
        <div ref="limperSliderContainer"></div>
        <form>
            <div>
                <span style="background-color:green;color:white;width:25px;">
                    {{ percentage_delete }}
                </span>% Delete
            </div>
            <div>
                <span style="background-color:#FFCC00;color:white;width:25px;">
                    {{ percentage_auto }}
                </span>% Move As-is, Automatically
            </div>
            <div>
                <span style="background-color:orange;color:white;width:25px;">
                    {{ percentage_manual }}
                </span>% Move As-is, Manually
            </div>
            <div>
                <span style="background-color:red;color:white;width:25px;">
                    {{ percentage_rewrite }}
                </span>% Rewrite
            </div>
        </form>
        <div v-if="crawl_completed">
            <el-button type="primary" style="margin-top:20px" v-on:click="implications">See the implications of these assignments</el-button>
        </div>
        <div v-else style="padding-top:20px;">
            Once the crawl is complete you can see the implications of your assignments.
        </div>
    </div>
</template>
<script>
    const LimperSlider = require('../../lib/limperslider');
    require('../../lib/limperslider.css');

    export default {
        props: ['crawl_completed'],
        data() {
            return {
                percentage_delete: null,
                percentage_auto: null,
                percentage_manual: null,
                percentage_rewrite: null
            }
        },
        mounted() {
            this.fetchRemotePercentages().then((percentages) => {
                if ((this.percentage_delete = percentages.percentage_delete) === null) this.percentage_delete = 25;
                if ((this.percentage_auto = percentages.percentage_auto) === null) this.percentage_auto = 25;
                if ((this.percentage_manual = percentages.percentage_manual) === null) this.percentage_manual = 25;
                if ((this.percentage_rewrite = percentages.percentage_rewrite) === null) this.percentage_rewrite = 25;

                this.renderLimperSlider();
            });
        },
        methods: {
            implications() {
                console.log(this.percentage_delete)
                axios.post('/api/free_percentages', {
                    percentage_delete: this.percentage_delete,
                    percentage_auto: this.percentage_auto,
                    percentage_manual: this.percentage_manual,
                    percentage_rewrite: this.percentage_rewrite,
                }).then(response => {
                    console.log(response)
                    window.location.href = '/implications'
                }).catch(error => {
                    console.log('oops saving the selected percentages')
                    console.log(error.response)
                })
            },
            fetchRemotePercentages() {
                return axios.get('/api/free_percentages').then(({ data }) => {

                    const percentage_delete = data.find((x) => x.slug === 'drop-and-forget').percentage;
                    const percentage_auto = data.find((x) => x.slug === 'move-as-is-auto').percentage;
                    const percentage_manual = data.find((x) => x.slug === 'move-as-is-manual').percentage;
                    const percentage_rewrite = data.find((x) => x.slug === 'rewrite-one-for-one').percentage;

                    return { percentage_delete, percentage_auto, percentage_manual, percentage_rewrite };
                }).catch(e => console.error(e)); //@TODO handle request failure
            },
            renderLimperSlider() {

                if (this.limperSlider !== undefined) {
                    this.limperSlider.destroy();
                    this.$refs.limperSliderContainer.removeEventListener('change', this.handleLimperSliderChange);
                }

                let inputElements = [];

                //Hardcoded for the 4 percentages for now
                const inputElementDelete = document.createElement('input');
                inputElementDelete.value = this.percentage_delete;
                inputElementDelete.id = 'percentage-delete';

                const inputElementAuto = document.createElement('input');
                inputElementAuto.value = this.percentage_auto;
                inputElementAuto.id = 'percentage-auto';

                const inputElementManual = document.createElement('input');
                inputElementManual.value = this.percentage_manual;
                inputElementManual.id = 'percentage-manual';

                const inputElementRewrite = document.createElement('input');
                inputElementRewrite.value = this.percentage_rewrite;
                inputElementRewrite.id = 'percentage-rewrite';

                inputElements.push(inputElementDelete, inputElementAuto, inputElementManual, inputElementRewrite);

                this.limperSlider = new LimperSlider(inputElements, {
                    element: this.$refs.limperSliderContainer,
                    colors: ['green','#FFCC00','orange','red']
                });

                this.$refs.limperSliderContainer.addEventListener('change', this.handleLimperSliderChange);
            },
            handleLimperSliderChange() {
                const inputElementDelete = this.limperSlider.state.inputs.find(i => i.id === 'percentage-delete');
                const inputElementAuto = this.limperSlider.state.inputs.find(i => i.id === 'percentage-auto');
                const inputElementManual = this.limperSlider.state.inputs.find(i => i.id === 'percentage-manual');
                const inputElementRewrite = this.limperSlider.state.inputs.find(i => i.id === 'percentage-rewrite');

                this.percentage_delete = parseInt(inputElementDelete.value);
                this.percentage_auto = parseInt(inputElementAuto.value);
                this.percentage_manual = parseInt(inputElementManual.value);
                this.percentage_rewrite = parseInt(inputElementRewrite.value);
            }
        }
    }

</script>